var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-input',{attrs:{"disabled":_vm.disabled,"id":_vm.inputId,"formatter":_vm.numberFormat,"lazy-formatter":_vm.isLazyFormatter,"trim":""},model:{value:(_vm.displayInput),callback:function ($$v) {_vm.displayInput=$$v},expression:"displayInput"}})
}
var staticRenderFns = []

export { render, staticRenderFns }